import {Button, Card, Placeholder} from 'react-bootstrap';
import { Link } from 'react-router-dom';

export function DashboardCard({ title, description, link, isLoading, value }) {
    var card_color = 'secondary';
    if(!isLoading) {
        if(value > 0){
            card_color = 'warning';
        } else {
            card_color = 'success';
        }
    }
    return (
        <Card border={card_color} className="border-2">
            <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                <Card.Title>{title}</Card.Title>
                <Card.Text>{description}</Card.Text>
                {isLoading ?
                    <Placeholder animation="glow" as="h1" xs={5} className="lh-1 my-0"><Placeholder className="display-1" xs={12}/></Placeholder>
                    : <div className="display-1 fw-bold lh-1">{value}</div>
                }
            </Card.Body>
            <Card.Footer className="bg-transparent border-0 pt-0">
                <div className="d-grid gap-2">
                    <Button as={Link} to={link} variant={card_color}>Open view</Button>
                </div>
            </Card.Footer>
        </Card>
    );
}
